const ENDPOINT_URL = '/live-event-admin/v1/live-text/time';

class TimeService {
    static getTime() {
        return fetch(ENDPOINT_URL).then((response) => response.json());
    }
}

export default TimeService;
